// src/services/vraboteniAPI.js
import api from "@/api";

export async function getVraboteniAPI() {
  try {
    const res = await api.get("/get/vraboteni");
    return res.data;
  } catch (err) {
    console.warn("API падна, враќам празна листа", err);
    return [];
  }
}